export enum PassengerTypeEnum {
  ADULT = 'ADT',
  CHILD = 'CNN',
  INFANT = 'INF',
}
